import { gql, useQuery } from "@apollo/client";
import { UsefulSectionPermissionList } from "src/layouts/AVC_Main/config/MainPermissionListConfig";
import useRequestConfig from "src/utils/hook/base/useRequestConfig";

const Q_CheckNewMessage = gql`
  query getCheckNewMessage {
    checkNewMessage {
      count
    }
  } 
`;

function useGetCheckNewMessage(skip) {
  const {requestConfig}=useRequestConfig();
  const { loading, error, data, refetch } = useQuery(Q_CheckNewMessage,
    requestConfig({module:"AVC_TICKET",errorShow:"OFF",
      Microservice:UsefulSectionPermissionList.checkNewMessage}
  )
);

  return { loading, error, data, refetch };
}
export default useGetCheckNewMessage;
